import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiExpectedReceivablesByDate = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbydate/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesTotal = async (accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbydate/total/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesNext = async (accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbydate/next/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const apiReceivablesList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/receivables/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiReceivableDetail = async (id) => {

  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/receivables/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiReceivablesDownload = async (format, filters) => {
  try {
    const acceptHeader =
        format === 'csv'
            ? 'text/csv'
            : 'application/vnd.ms-excel';

    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/receivables/report/`, filters),
        {
          method: 'GET',
          headers: {
            ...buildHeaders(),
            Accept: acceptHeader,
          },
        }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

export const apiSmartFactoryDownload = async (format, filters) => {
  try {
    const acceptHeader =
        format === 'csv'
            ? 'text/csv'
            : 'application/vnd.ms-excel';

    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/receivables/smartfactory_report/`, filters),
        {
          method: 'GET',
          headers: {
            ...buildHeaders(),
            Accept: acceptHeader,
          },
        }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesByMonth = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbymonth/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};